import { component } from 'picoapp';
import { setCookie, hasCookie } from '../lib/utils';
import $ from 'quantdom';

export default component((node) => {
	const url = new URL(window.location);
	const params = url.searchParams;

	if (params.has('b2b', 'lfc')) {
		setCookie('b2b', 'lfc', 30);
	}

	if (hasCookie('b2b', 'lfc')) {
		//$('#announcement-bar').css('background-color', '#000');
		if (
			url.pathname.includes('/collections/lfc') ||
			url.pathname.includes('/collections/swthz')
		) {
			$('#announcement-bar').html(
				`<p class="t-b-2 tw-text-xs md:tw-text-sm">
				SweatHouz Private Collection</p>`
			);
		} else {
			$('#announcement-bar').html(
				`<a href="/collections/lfc"><p class="t-b-2 tw-text-xs !tw-text-[#FF0203] md:tw-text-sm">
			   DO NOT CLICK "SHOP PRINTS" -> Click here to navigate back to Private SWTHZ Collection</p></a>`
			);
		}
	}
});
